import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M3 17.3438C3 17.9133 3.46171 18.375 4.03125 18.375H19.9688C20.5383 18.375 21 17.9133 21 17.3438C21 16.7742 20.5383 16.3125 19.9688 16.3125H4.03125C3.46171 16.3125 3 16.7742 3 17.3438ZM3 12.1875C3 12.757 3.46171 13.2188 4.03125 13.2188H19.9688C20.5383 13.2188 21 12.757 21 12.1875C21 11.618 20.5383 11.1562 19.9688 11.1562H4.03125C3.46171 11.1562 3 11.618 3 12.1875ZM4.03125 6C3.46171 6 3 6.46171 3 7.03125C3 7.60079 3.46171 8.0625 4.03125 8.0625H19.9688C20.5383 8.0625 21 7.60079 21 7.03125C21 6.46171 20.5383 6 19.9688 6H4.03125Z' />
        </SvgIcon>
    );
});
